import { DeviceEnrollmentOptions, NewUserFormInput } from '@xemplo/gp-types';

/**
 * RHF converts every field to string. This converts the payload back to the
 * correct types before sending to the API.
 */
export function sanitisePayload(data: NewUserFormInput): NewUserFormInput {
  return {
    ...data,
    // RHF serialises values as strings — ensure the literal string "true" maps to boolean true
    getNotifications:
      typeof data.getNotifications === 'string'
        ? data.getNotifications === 'true'
        : Boolean(data.getNotifications),
    // Note: null causes a BE error — 0 (Disabled) is the default value in db
    deviceEnrolmentEnable: Number(
      data.deviceEnrolmentEnable ?? DeviceEnrollmentOptions.Disabled,
    ),
    // addressId is required by the API even though there is no address section
    addressId: 0,
  };
}
